import type { AuthProfile } from "@/types/auth-types";

const PROFILE_STORAGE_KEY = "auth_profile";

export function storeAuthProfile(profile: AuthProfile): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(profile));
}

export function getAuthProfile(): AuthProfile | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(PROFILE_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthProfile;
  } catch {
    return null;
  }
}

export function clearAuthProfile(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(PROFILE_STORAGE_KEY);
}
